import { createContext } from "react";
const collectionContext = createContext();
export default collectionContext;
